export function cleanModel(content) {
  return content?.replaceAll("{{", "{").replaceAll("}}", "}")
}